import GallerySlider from './gallery-slider';

export default class GallerySliderDesktop extends GallerySlider {
}
